import { FormControl, FormGroup, Validators } from '@angular/forms';

export class MarketingConsentsForm extends FormGroup {
  constructor() {
    super({
      electronicMarketing: new FormControl(false),
      phoneMarketing: new FormControl(false),
    });
  }

  get phoneMarketing(): FormControl {
    return this.get('phoneMarketing') as FormControl;
  }

  get electronicMarketing(): FormControl {
    return this.get('electronicMarketing') as FormControl;
  }

  get allMarketingSelected(): boolean {
    return this.phoneMarketing.value && this.electronicMarketing.value;
  }

  get anyMarketingSelected(): boolean {
    return this.phoneMarketing.value || this.electronicMarketing.value;
  }

  public changeAllMarketingConsentsState(checked: boolean): void {
    this.phoneMarketing.setValue(checked);
    this.electronicMarketing.setValue(checked);
  }

  public requireAllAndSetFalse(): void {
    this.phoneMarketing.setValidators([Validators.requiredTrue]);
    this.phoneMarketing.setValue(false);
    this.electronicMarketing.setValidators([Validators.requiredTrue]);
    this.electronicMarketing.setValue(false);
  }

  public removeRequireAll(): void {
    this.phoneMarketing.setValidators([]);
    this.electronicMarketing.setValidators([]);
  }
}
